
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class QuickActionsBar extends Vue {
  @Prop({ default: 0 }) pendingApprovals!: number;

  showTip = true;
  tipIndex = 0;

  tips = [
    'You can import multiple POs at once using our CSV template.',
    'Set up automation to create POs automatically based on reorder points.',
    'Review pending approvals regularly to keep your procurement flowing.',
    'Use keyboard shortcuts: Ctrl+N for new PO, Ctrl+I for import.'
  ];

  get currentTip() {
    return this.tips[this.tipIndex % this.tips.length];
  }

  mounted() {
    // Randomly select a tip
    this.tipIndex = Math.floor(Math.random() * this.tips.length);
    
    // Load tip preference from localStorage
    const hideTips = localStorage.getItem('po-dashboard-hide-tips');
    if (hideTips === 'true') {
      this.showTip = false;
    }
  }

  handleAction(action: string) {
    this.$emit('action', action);
  }

  hideTip() {
    this.showTip = false;
    localStorage.setItem('po-dashboard-hide-tips', 'true');
  }
}
